import { InputAdornment, TextField } from '@mui/material';
import type { KeyboardEvent } from 'react';
import { DynamicIcon } from 'src/components';

interface MacrosModalSearchProps {
  value: string;
  onChange: (value: string) => void;
  onKeyDown: (event: KeyboardEvent<HTMLInputElement>) => void;
}

export const MacrosModalSearch = ({ value, onChange, onKeyDown }: MacrosModalSearchProps) => {
  return (
    <TextField
      autoFocus
      value={value}
      placeholder="Search macros..."
      variant="standard"
      fullWidth
      onChange={(event) => {
        onChange(event.target.value);
      }}
      onKeyDown={onKeyDown}
      InputProps={{
        disableUnderline: true,
        startAdornment: (
          <InputAdornment position="start">
            <DynamicIcon name="search" />
          </InputAdornment>
        ),
      }}
    />
  );
};
